import { Injectable } from '@angular/core';
import { Apollo } from 'apollo-angular';
import gql from 'graphql-tag';

@Injectable()
export class QualityReferenceQueryService {

    public CREATE_REFERENCE: any;
    public GET_REFERENCES_DATA: any;

    constructor(public apollo: Apollo) {

        /* To create user */
        this.CREATE_REFERENCE = gql` 
          mutation CREATE_REFERENCE($input: CreateQualityReferenceInput!) {
            createQualityReference(input: $input) {
                qualityReference{
                  userId
                 }
            }
           }
        `;

        this.GET_REFERENCES_DATA =
            gql`
           query currentScheduleRequests($userId:UUID){                           
                allQualityReferences(condition:{userId:$userId}) {
                    nodes {
                        name
                        email
                        phone
                        userId
                    }
                }
            }
        `  ;
    }

    CREATEREFERENCE(values, userId): any {

        return this.apollo.mutate({
            mutation: this.CREATE_REFERENCE,
            variables: {
                "input": {
                    "qualityReference": {
                        "name": values.name,
                        "email": values.email,
                        "phone": values.phone,
                        "userId": userId
                    }
                }
            }
        })
    }

    FETCH_REFERENCES(userId): any {
        return this.apollo
            .watchQuery({
                query: this.GET_REFERENCES_DATA
                ,
                variables:
                {
                    "userId": userId
                },
                fetchPolicy: 'network-only'
            });
    }
}


// WEBPACK FOOTER //
// E:/NeoSME/1.Full Project Spekwo/pro/prodash/src/app/main/content/apps/gql-query-mutation/qualityReference.ts